import { useState } from "react";
import { FiBookOpen } from "react-icons/fi";

export interface BookCoverProps {
  author: string;
  className?: string;
  loading?: "eager" | "lazy";
  src?: string;
  title: string;
}

export function BookCover({
  author,
  className = "",
  loading = "lazy",
  src,
  title,
}: BookCoverProps) {
  const [failed, setFailed] = useState<boolean>(false);

  if (src && !failed) {
    return (
      <img
        alt=""
        className={`bg-line object-cover ${className}`}
        decoding="async"
        height="480"
        loading={loading}
        onError={() => setFailed(true)}
        src={src}
        width="320"
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      className={`flex flex-col items-center justify-center bg-ink px-3 text-center text-surface ${className}`}
    >
      <FiBookOpen className="mb-3 h-7 w-7 text-gold" />
      <span className="font-display text-lg leading-tight">{title}</span>
      <span className="mt-2 text-[0.65rem] uppercase tracking-widest text-surface/70">
        {author}
      </span>
    </div>
  );
}
